import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function ArticlesSection() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-600 text-sm">游戏攻略、技巧分享与平台动态</p>
          </div>
          <Link
            to="/article/pg-monitiqi-xinshou-gonglue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex flex-col gap-4">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.slug}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              category={article.category}
              date={article.date}
              readTime={article.readTime}
              image={article.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
}